import React from 'react';

export default (props) => {
    return (
        <React.Fragment>
            <div
                className={props.focus == 'chatbot' ? `${props.classes.focus}` : props.classes.notFocus}
                data-testid="chatbot-tab"
            >
                <svg width="18px" height="18px" viewBox="0 0 24 24" fill="#b3d4f5" xmlns="http://www.w3.org/2000/svg">
                    <g strokeWidth="0"></g>
                    <g strokeLinecap="round"></g>
                    <g>
                        {' '}
                        <path
                            d="M3 5V20.7929C3 21.2383 3.53857 21.4614 3.85355 21.1464L7.70711 17.2929C7.89464 17.1054 8.149 17 8.41421 17H19C20.1046 17 21 16.1046 21 15V5C21 3.89543 20.1046 3 19 3H5C3.89543 3 3 3.89543 3 5Z"
                            stroke="#b3d4f5"
                            strokeWidth="2"
                            strokeLinecap="round"
                        ></path>{' '}
                        <path
                            d="M15 12C14.2005 12.6224 13.1502 13 12 13C10.8498 13 9.79952 12.6224 9 12"
                            stroke="#000000"
                            strokeWidth="2"
                            strokeLinecap="round"
                        ></path>{' '}
                        <path d="M9 8.01953V8" stroke="#000000" strokeWidth="2" strokeLinecap="round"></path>{' '}
                        <path d="M15 8.01953V8" stroke="#000000" strokeWidth="2" strokeLinecap="round"></path>{' '}
                    </g>
                </svg>
                {'ChatBot'}
            </div>
        </React.Fragment>
    );
};
